/** Dispositivo con puntero grueso (dedo) como input principal. */
export function isTouchPrimary(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(pointer: coarse)").matches;
}

/**
 * Móvil / tablet en mano (UA + pantalla estrecha).
 *
 * La guarda mira `window`, no `navigator`. Parece lo mismo y no lo es: Node
 * trae un `navigator` global desde la 21 (con `userAgent` "Node.js/…"), así que
 * la comprobación de antes pasaba de largo y reventaba dos líneas más abajo al
 * llamar a `window.matchMedia`. Lo destapó un test del encuadre, que no tiene
 * navegador ninguno.
 */
export function isMobileHandheld(): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  const mobileUa = /Android|iPhone|iPad|iPod|Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const narrow = window.matchMedia("(max-width: 900px)").matches;
  return mobileUa || (isTouchPrimary() && narrow);
}

/** ¿Conviene mostrar controles táctiles en partido? */
export function wantsTouchControls(): boolean {
  return isTouchPrimary() || isMobileHandheld();
}
